import React from 'react';
import { connect } from 'react-redux';
import { selectPayment, saveBillingInfo } from '../../../../../../../Redux/Actions/EndUser/BillingAction';
import { setTransactionId } from '../../../../../../../Redux/Actions/EndUser/StoreActions';
import { fetchStates } from '../../../../../../../Redux/Actions/CommonActions';
import { FormGroup, Label, Input } from 'reactstrap';
import CardPayment from '../CardPayment';
import ACHPayment from '../ACHPayment';
import CheckPayment from '../CheckPayment';
import './BillingInformation.scss';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { withRouter } from 'react-router-dom';
import { Alert } from 'reactstrap';
import IsLoading from '../../../../../../Shared/Loading/IsLoading';
import { history } from '../../../../../../../helpers/history';

const optionalBilling = 'Optional: Billing Information'
const billing = 'Billing Information'

class BillingInformation extends React.Component {

    constructor(props) {
        super(props);
        //this.handleInputChange = this.handleInputChange.bind(this);  
        this.state = {
            cardInfo: {},
            BillingAddress1: "",
            BillingAddress2: "",
            BillingCity: "",
            BillingZip: "",
            Email: "",
            Phone: "",
            BillingStateId: 0,
            UserId: "",
            IsACH:false,
            StateObject: { id: 0, name: "" },
            UseBillingInfo: false,
            touched: {
                address1: false,
                city: false,
                state: false,
                zip: false,
                phone: false
            },
            states: [],
            TransactionId :0
        };

    }

    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevProps.states !== this.props.states ||
    //         prevProps.states.length !== this.props.states.length) {
    //             var arr = [{ id: 0, name: "Select State" }]
    //             this.props.states.forEach(element => {
    //                 arr.push(element);
    //             });
    //         this.setState({
    //             states: arr
    //         });
    //     }
    // }

    handleClick = (event) => {
        this.setState({
          condition: !this.state.condition
        });
      }

    componentDidMount() {
        console.log('billing info');
        this.props.fetchStates();
        this.handleuserId();
       
    }

    componentWillUpdate(nextProps){
        if(nextProps.billing.billingResponse !== null){
            this.props.nextStep();
        }
    }

    
    handleuserId = (event) =>{
       const params = new URL(window.location.href).searchParams;
       this.setState({ 
           UserId: params.get('userId') 
        });
    }
    handlePaymentOption = (event) => {
        this.props.selectPayment(event.target.value);
        this.setState({
            IsACH:event.target.value
        });
    }

    handlePhoneCHange = (event) => {
        event.target.value = this.formatPhone(event.target.value);
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    billingInfoToggle = () => {
        if (!this.state.UseBillingInfo) {
            this.populateBillingInfo();
        } else {
            this.setState({
                BillingAddress1: '',
                BillingAddress2: '',
                BillingCity: '',
                BillingZip: '',
                Email: '',
                Phone: '',
                BillingStateId: '',
                StateObject: {
                    id: 0,
                    name: ""
                },
            });
        }
        this.setState({
            UseBillingInfo: !this.state.UseBillingInfo
        });
    }

    populateBillingInfo = () => {
        if (this.props.membership !== null && this.props.membership.inputMembershipInformation !== null) {
            this.setState({
                BillingAddress1: this.props.membership.membershipInformation.MailingAddress1,
                BillingAddress2: this.props.membership.membershipInformation.MailingAddress2,
                BillingCity: this.props.membership.membershipInformation.MailingCity,
                BillingZip: this.props.membership.membershipInformation.MailingZip,
                Phone: this.props.membership.membershipInformation.Phone,
                Email: this.props.membership.membershipInformation.Email,
                BillingStateId: this.props.membership.membershipInformation.MailingStateId,
                StateObject: this.props.membership.membershipInformation.StateObject
            });
        }
    }

    //handleSubmit = (event) => {
    //    event.preventDefault();

    //    if (this.isFreeAccount()) {
    //        //this.setTransactionId(response.data.transactionId);
    //        history.push('/payment');
    //    } else {
    //        if (this.isModelValid()) {
    //            this.props.saveBillingInfo(this.state);
    //            //window.location = '/';  //this needs to be changed later once we have the additional steps hooked up
    //        } else {
    //            this.setAllTouchedTrue();
    //        }
    //    }
    //}

    cardStateChange = (cardInfo) => {
        this.setState({
            cardInfo: cardInfo
        })
    }

    setAllTouchedTrue = () => {
        this.setState({
            touched: {
                address1: true,
                city: true,
                state: true,
                zip: true,
                phone: true
            }
        })
    }

    // handleState = (event) => {
    //     const target = event.target;
    //     console.log("lol")
    //     console.log("state in billing",event.target.value);
    //     var obj = this.state.states.find(st => st.id === target.value);
    //     console.log("state obj",obj);
    //     this.setState({
    //         BillingStateId: event.target.value,
    //         StateObject: obj
    //     })
    // }
    

    handleState = (event) => {
        this.setState({
            StateObject: event.target.value,
            BillingStateId: event.target.value.id
        })
    }

    isFreeAccount() {
        if (this.props.membership.selectedMembershipType && this.props.membership.selectedMembershipType.description === 'Free Account') {
            return true;
        } else {
            return false;
        }
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid = () => {
        //if (!this.isFreeAccount()) {
        return this.state.BillingAddress1 !== "" &&
            this.state.BillingCity !== "" &&
            this.state.StateObject.name !== "" &&
            this.state.BillingZip !== "" &&
            this.state.Phone !== "";
        //} else {
        //    return true;
        //}
    }

    handleZipChange = (event) => {
        var originalValue = this.state.BillingZip;
        var value = event.target.value.replace(/\D/g, '');
        if ((value.match(/^[0-99999]|^$/) || value == "") && value.length <= 5) {
            this.setState({
                BillingZip: value
            });
        }
        else {
            this.setState({
                BillingZip: originalValue
            });
        }
    }

    render() {
        return (
            <div className="billing-info cols">
                <div className="row">
                    {this.props.common.visible && !this.props.signup  ? (
                        <div className="col-lg-12">
                            <Alert
                                color={this.props.common.color}
                                isOpen={this.props.common.visible}
                                style={{ width: '100%' }}
                            >
                                {this.props.common.message}
                            </Alert>
                        </div>
                    ) : null}
                </div>
                <form className="billingForm" onSubmit={this.handleSubmit}>
                    <div className="card borderBottom">
                        <div className="card-body">
                            <h1 className="pt-3 pb-3"><span className="blue">{this.isFreeAccount() ? optionalBilling : billing}</span></h1>
                            <h3>Enter your <span className="highlight">billing</span> address</h3>
                            <div className="form-group">
                                <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                    <input
                                        type="checkbox"
                                        onClick={this.handleClick}
                                        className="custom-control-input"
                                        onChange={this.billingInfoToggle}
                                        name="UseBillingInfo"
                                        value={this.state.UseBillingInfo}
                                        id="UseBillingInfo"
                                    />
                                    <label htmlFor="UseBillingInfo">
                                        <span className={this.state.condition ? " far fa-check-square" : "far fa-square"}></span>
                                        <span className="custom-control-text">Use my mailing information for billing information.</span>
                                    </label>
                                </div>
                            </div>
                            <div>
                                <div className="mailingAddressContainer">
                                    <FormGroup className="address1-wrapper">
                                        <Label htmlFor="BillingAddress1" className={this.state.touched.address1 && !this.state.BillingAddress1 ? 'error' : ''}>Address 1</Label>
                                        <Input type="text"
                                            id="BillingAddress1"
                                            value={this.state.BillingAddress1}
                                            onChange={this.handleChange}
                                            name="BillingAddress1"
                                            onBlur={this.handleBlur('address1')}
                                            invalid={this.state.touched.address1 && !this.state.BillingAddress1 ? true : false}
                                        />
                                    </FormGroup>

                                    <FormGroup className="address2-wrapper">
                                        <Label htmlFor="BillingAddress2">Address 2</Label>
                                        <Input type="text"
                                            id="BillingAddress2"
                                            value={this.state.BillingAddress2}
                                            onChange={this.handleChange}
                                            name="BillingAddress2"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            <div>
                                <div className="cityStateZip">
                                    <FormGroup className="city-wrapper">
                                        <Label htmlFor="BillingCity" className={this.state.touched.city && !this.state.BillingCity ? 'error' : ''}>City</Label>
                                        <Input type="text"
                                            id="BillingCity"
                                            value={this.state.BillingCity}
                                            onChange={this.handleChange}
                                            name="BillingCity"
                                            onBlur={this.handleBlur('city')}
                                            invalid={this.state.touched.city && !this.state.BillingCity ? true : false}
                                        />
                                    </FormGroup>

                                    <FormGroup className="state-wrapper">
                                        <label htmlFor="billingState" className={this.state.touched.state && this.state.StateObject.name === '' ? "error" : ""}>State </label>
                                        <DropDownList data={this.props.common.states}
                                            id="billingState"
                                            name="billingState"
                                            textField="name"
                                            dataItemKey="id"
                                            onChange={this.handleState}
                                            value={this.state.StateObject}
                                            // style={{ width: "100px" }}
                                            className={this.state.touched.state && this.state.StateObject.name === '' ? "error" : ""}
                                            onBlur={this.handleBlur('state')}
                                        />
                                    </FormGroup>

                                    <FormGroup className="zip-wrapper">
                                        <Label htmlFor="BillingZip" className={this.state.touched.zip && !this.state.BillingZip ? 'error' : ''}>Zip Code</Label>
                                        <Input type="text"
                                            id="BillingZip"
                                            value={this.state.BillingZip}
                                            onChange={this.handleZipChange}
                                            name="BillingZip"
                                            onBlur={this.handleBlur('zip')}
                                            invalid={this.state.touched.zip && !this.state.BillingZip ? true : false}
                                            pattern="(\d{5}([\-]\d{4})?)"
                                            placeholder="12345"
                                            title="Zip Code (Format: 12345 or 12345-6789)"
                                        />
                                    </FormGroup>

                                    <FormGroup className="phone-wrapper">
                                        <Label htmlFor="Phone" className={this.state.touched.phone && !this.state.Phone ? 'error' : ''}>Phone</Label>
                                        <Input type="text"
                                            id="Phone"
                                            value={this.state.Phone}
                                            onChange={this.handlePhoneCHange}
                                            name="Phone"
                                            onBlur={this.handleBlur('phone')}
                                            invalid={this.state.touched.phone && !this.state.Phone ? true : false}
                                            pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
                                            title="Phone Number (Format: (123) 456-7890)"
                                            placeholder="(123) 456-7890"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <div className="form-group">
                                <div className="custom-control">

                                    <div className="col-left">
                                        <input type="radio"
                                            className="custom-control-input"
                                            id="cardRadio"
                                            name="cardRadio"
                                            onChange={this.handlePaymentOption}
                                            checked={this.props.billing.selectedPayment === 'Card'}
                                            value="Card" />
                                        <label htmlFor="cardRadio">
                                            <span className={this.props.billing.selectedPayment === 'Card' ? "fas fa-check-circle" : "far fa-circle"}></span>
                                            <span>Card Payment</span>
                                        </label>
                                    </div>
                                    {/*
                                            <div className="col-right">
                                                <input type="radio"
                                                    className="custom-control-input"
                                                    id="checkRadio"
                                                    name="checkRadio"
                                                    onChange={this.handlePaymentOption}
                                                    checked={this.props.billing.selectedPayment === 'ACH'}
                                                    value="ACH" />
                                                <label htmlFor="checkRadio">
                                                    <span className={this.props.billing.selectedPayment === 'ACH' ? "fas fa-check-circle" : "far fa-circle"}></span>
                                                    <span>Bank Account Payment</span>
                                                </label>
                                            </div>
                                        */}
                                </div>
                            </div>
                            {this.props.billing.selectedPayment === "Card" && <CardPayment cardInfo={this.state.cardInfo} cardStateChange={this.cardStateChange} billingInfo={this.state} billingModelValid={this.isModelValid} billingSetAllTouchedTrue={this.setAllTouchedTrue} />}
                            {this.props.billing.selectedPayment === "ACH" && <ACHPayment billingInfo={this.state} />}
                            {this.props.billing.selectedPayment === "Check" && <CheckPayment billingInfo={this.state} />}
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        common: state.common,
        billing: state.billing
    }
}

export default withRouter(connect(mapStateToProps, { fetchStates, CardPayment, ACHPayment, CheckPayment, selectPayment, saveBillingInfo, setTransactionId })(BillingInformation));

